/**
 * WordPress dependencies
 */
import {
	Icon as WCIcon,
	__experimentalInputControlPrefixWrapper as InputControlPrefixWrapper,
} from '@wordpress/components';
import { mobile } from '@wordpress/icons';

/**
 * Internal dependencies
 */
import type { DataFormControlProps } from '../../types';
import ValidatedText from './utils/validated-input';

export default function Telephone< Item >( {
	data,
	field,
	onChange,
	hideLabelFromVision,
	markWhenOptional,
	validity,
}: DataFormControlProps< Item > ) {
	return (
		<ValidatedText
			{ ...{
				data,
				field,
				onChange,
				hideLabelFromVision,
				markWhenOptional,
				validity,
				type: 'tel',
				prefix: (
					<InputControlPrefixWrapper variant="icon">
						<WCIcon icon={ mobile } />
					</InputControlPrefixWrapper>
				),
			} }
		/>
	);
}
